const NoTransactions = () => {
  return (
    <svg
      width="148"
      height="148"
      viewBox="0 0 148 148"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="148" height="148" rx="74" fill="#F6F8FA" />
      <path
        d="M87.1275 115.503L102.419 102.404C105.808 99.5009 106.202 94.3988 103.299 91.0096C101.122 88.4689 97.7156 87.6115 94.7188 88.5685L94.3344 88.7017L75.6992 94.9966C80.1443 93.5835 85.201 94.85 88.4313 98.6209C92.7316 103.641 92.1476 111.203 87.1275 115.503Z"
        fill="#CDD0D5"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.699 94.9943L94.3341 88.6994L94.7186 88.5662C97.7153 87.6092 101.122 88.4666 103.299 91.0072L62.242 43.0781L31.7207 69.223L70.2455 114.197C74.5458 119.217 82.107 119.801 87.1272 115.5C92.1473 111.2 92.7314 103.639 88.431 98.6187C85.2008 94.8477 80.144 93.5812 75.699 94.9943Z"
        fill="white"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.6992 94.9961L75.4824 95.0674"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M70.1376 92.9548C75.5336 92.9548 79.9079 88.5805 79.9079 83.1844C79.9079 77.7884 75.5336 73.4141 70.1376 73.4141C64.7415 73.4141 60.3672 77.7884 60.3672 83.1844C60.3672 88.5805 64.7415 92.9548 70.1376 92.9548Z"
        fill="#868C98"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.0008 74.2219C38.763 71.8557 39.0834 67.7076 36.7172 64.9453L31.7207 69.2253L36.0008 74.2219Z"
        fill="#868C98"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.5228 48.0747L62.2427 43.0781L57.2461 47.3583C59.6123 50.1205 63.7605 50.4409 66.5228 48.0747Z"
        fill="#868C98"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M97.8893 98.0425L108.883 81.1741C111.319 77.4354 110.263 72.4281 106.525 69.9916C103.722 68.165 100.211 68.2997 97.6045 70.0605L97.2729 70.2964L81.1582 81.5752C85.0269 78.9697 90.2358 78.7638 94.3957 81.4748C99.9337 85.084 101.498 92.5047 97.8893 98.0425Z"
        fill="#E2E4E9"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M81.1578 81.5725L97.2725 70.2937L97.6041 70.0578C100.211 68.2971 103.722 68.1624 106.524 69.9889L53.6517 35.5312L31.709 69.2006L81.3212 101.533C86.8592 105.143 94.2798 103.578 97.889 98.0398C101.498 92.502 99.9333 85.0813 94.3954 81.4721C90.2355 78.7611 85.0266 78.967 81.1578 81.5725Z"
        fill="white"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M81.1587 81.5742L80.9707 81.7036"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72.5034 82.7451C78.5459 82.7451 83.4444 77.8467 83.4444 71.8042C83.4444 65.7617 78.5459 60.8633 72.5034 60.8633C66.4609 60.8633 61.5625 65.7617 61.5625 71.8042C61.5625 77.8467 66.4609 82.7451 72.5034 82.7451Z"
        fill="#CDD0D5"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.2209 72.7954C39.2067 69.7483 38.3482 65.6773 35.3011 63.6914L31.709 69.2032L37.2209 72.7954Z"
        fill="#868C98"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M59.1646 39.1234L53.6527 35.5312L50.0605 41.0432C53.1077 43.0291 57.1788 42.1706 59.1646 39.1234Z"
        fill="#868C98"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M66.5488 68.8281L69.4868 71.7627L66.5488 68.8281Z"
        fill="#CDD0D5"
      />
      <path
        d="M66.5488 68.8281L69.4868 71.7627"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M69.4854 68.8281L66.5508 71.7661L69.4854 68.8281Z"
        fill="#CDD0D5"
      />
      <path
        d="M69.4854 68.8281L66.5508 71.7661"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M75.5176 68.8242L78.4556 71.7588L75.5176 68.8242Z"
        fill="#CDD0D5"
      />
      <path
        d="M75.5176 68.8242L78.4556 71.7588"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.4541 68.8203L75.5195 71.7583L78.4541 68.8203Z"
        fill="#CDD0D5"
      />
      <path
        d="M78.4541 68.8203L75.5195 71.7583"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.3848 74.7817L75.998 74.7773L68.3848 74.7817Z"
        fill="#CDD0D5"
      />
      <path
        d="M68.3848 74.7817L75.998 74.7773"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.0054 112.894C40.4644 112.894 44.0791 109.279 44.0791 104.82C44.0791 100.361 40.4644 96.7461 36.0054 96.7461C31.5464 96.7461 27.9316 100.361 27.9316 104.82C27.9316 109.279 31.5464 112.894 36.0054 112.894Z"
        fill="#E2E4E9"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.9998 58.6949C41.3963 58.6949 46.5816 53.5096 46.5816 47.1131C46.5816 40.7166 41.3963 35.5312 34.9998 35.5312C28.6033 35.5312 23.418 40.7166 23.418 47.1131C23.418 53.5096 28.6033 58.6949 34.9998 58.6949Z"
        fill="#E2E4E9"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M120.001 110.08C124.843 110.08 128.769 106.154 128.769 101.311C128.769 96.4687 124.843 92.543 120.001 92.543C115.158 92.543 111.232 96.4687 111.232 101.311C111.232 106.154 115.158 110.08 120.001 110.08Z"
        fill="#E2E4E9"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M119.838 106.136C119.567 106.101 119.314 105.973 119.118 105.771C118.903 105.548 118.787 105.285 118.772 104.978C118.741 104.387 119.136 103.866 119.725 103.722C119.803 103.703 119.845 103.699 119.986 103.698C120.211 103.698 120.362 103.73 120.532 103.816C120.949 104.026 121.201 104.413 121.219 104.871C121.237 105.326 121.013 105.737 120.615 105.977C120.393 106.111 120.107 106.169 119.838 106.136ZM118.567 103.387C118.513 103.36 118.035 102.883 118.009 102.83C117.992 102.794 117.99 102.773 117.993 102.667C117.996 102.566 118 102.538 118.017 102.505C118.041 102.459 118.23 102.273 118.365 102.164C118.662 101.923 119.052 101.734 119.424 101.649C119.63 101.603 119.752 101.59 120.001 101.59C120.25 101.59 120.372 101.603 120.577 101.649C120.949 101.734 121.339 101.923 121.636 102.164C121.788 102.287 121.967 102.466 121.986 102.513C122.007 102.565 122.016 102.765 122 102.815C121.984 102.864 121.493 103.359 121.433 103.387C121.378 103.413 121.282 103.414 121.227 103.389C121.203 103.378 121.161 103.341 121.123 103.299C121.036 103.201 120.9 103.089 120.776 103.015C120.225 102.683 119.527 102.738 119.031 103.152C118.982 103.194 118.913 103.26 118.878 103.299C118.84 103.341 118.798 103.378 118.774 103.389C118.719 103.414 118.619 103.413 118.567 103.387ZM117.133 101.96C117.081 101.934 116.575 101.422 116.562 101.383C116.556 101.365 116.553 101.3 116.554 101.234C116.557 101.138 116.562 101.109 116.578 101.077C116.618 101 116.981 100.664 117.218 100.483C117.596 100.196 118.107 99.9296 118.564 99.7817C119.593 99.449 120.716 99.4845 121.71 99.8813C122.079 100.029 122.484 100.256 122.784 100.483C123.021 100.664 123.383 101 123.423 101.077C123.44 101.109 123.444 101.138 123.447 101.234C123.448 101.3 123.445 101.365 123.439 101.383C123.425 101.425 122.908 101.944 122.86 101.964C122.816 101.983 122.721 101.982 122.672 101.963C122.646 101.953 122.601 101.912 122.534 101.84C122.181 101.461 121.669 101.137 121.141 100.958C120.757 100.827 120.418 100.772 120.001 100.772C119.583 100.772 119.244 100.827 118.86 100.958C118.332 101.137 117.82 101.461 117.467 101.84C117.4 101.912 117.355 101.953 117.329 101.963C117.277 101.984 117.177 101.982 117.133 101.96ZM115.689 100.51C115.632 100.484 115.149 99.9951 115.134 99.9478C115.127 99.9268 115.124 99.8657 115.126 99.795C115.128 99.6992 115.133 99.67 115.149 99.6379C115.18 99.5796 115.491 99.2796 115.724 99.0852C116.679 98.2856 117.824 97.7733 119.045 97.5989C119.419 97.5455 119.521 97.5391 120.001 97.5391C120.48 97.5391 120.583 97.5455 120.956 97.5989C122.177 97.7733 123.322 98.2856 124.277 99.0852C124.51 99.2796 124.822 99.5796 124.852 99.6379C124.869 99.67 124.873 99.6992 124.876 99.795C124.877 99.8656 124.874 99.9267 124.868 99.9477C124.851 99.9982 124.368 100.485 124.309 100.511C124.251 100.536 124.158 100.535 124.102 100.51C124.074 100.497 124.001 100.434 123.9 100.335C123.467 99.9116 123.04 99.6049 122.513 99.338C121.862 99.0077 121.216 98.8257 120.444 98.7544C120.156 98.7278 119.638 98.74 119.306 98.7814C118.671 98.8603 118.064 99.0462 117.488 99.3379C116.961 99.6048 116.534 99.9115 116.102 100.335C116 100.434 115.927 100.497 115.9 100.51C115.844 100.535 115.744 100.535 115.689 100.51Z"
        fill="#868C98"
      />
      <path
        d="M35.0006 40.8828C31.6558 40.8828 28.9414 43.6748 28.9414 47.1151C28.9414 50.5554 31.6558 53.3474 35.0006 53.3474C38.3453 53.3474 41.0597 50.5554 41.0597 47.1151C41.0597 43.6748 38.3453 40.8828 35.0006 40.8828ZM37.4609 50.0528C37.3583 50.0528 37.2948 50.0202 37.1995 49.9624C35.6749 49.0175 33.9011 48.9772 32.1493 49.3467C32.0541 49.3718 31.9295 49.412 31.8586 49.412C31.6216 49.412 31.4726 49.2185 31.4726 49.0149C31.4726 48.7561 31.6216 48.633 31.8049 48.5928C33.8058 48.1379 35.8508 48.1781 37.5953 49.2512C37.7443 49.3492 37.8323 49.4371 37.8323 49.6658C37.8323 49.8945 37.6588 50.0528 37.4609 50.0528ZM38.1181 48.4043C37.9911 48.4043 37.9056 48.3465 37.8176 48.2987C36.2906 47.3689 34.0135 46.9945 31.9881 47.5599C31.8708 47.5926 31.8073 47.6252 31.6974 47.6252C31.4359 47.6252 31.2234 47.4066 31.2234 47.1377C31.2234 46.8688 31.3504 46.6904 31.6021 46.6175C32.2813 46.4215 32.9752 46.2758 33.9915 46.2758C35.5772 46.2758 37.1091 46.6803 38.316 47.4192C38.5139 47.5398 38.5921 47.6956 38.5921 47.9142C38.5897 48.1856 38.3844 48.4043 38.1181 48.4043ZM38.8755 46.4894C38.7485 46.4894 38.6703 46.4567 38.5603 46.3914C36.8208 45.3233 33.7106 45.067 31.6974 45.645C31.6094 45.6701 31.4995 45.7103 31.3822 45.7103C31.0597 45.7103 30.8129 45.4515 30.8129 45.1173C30.8129 44.783 31.0181 44.582 31.238 44.5166C32.098 44.2578 33.0607 44.1347 34.1088 44.1347C35.8923 44.1347 37.7614 44.5166 39.1272 45.3359C39.3177 45.449 39.4423 45.6048 39.4423 45.9038C39.4423 46.2456 39.1736 46.4894 38.8755 46.4894Z"
        fill="#868C98"
      />
      <path
        d="M108.42 55.574C116.482 55.574 123.017 49.0384 123.017 40.9764C123.017 32.9144 116.482 26.3789 108.42 26.3789C100.358 26.3789 93.8223 32.9144 93.8223 40.9764C93.8223 49.0384 100.358 55.574 108.42 55.574Z"
        fill="#E2E4E9"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.279 37.0246C116.088 36.3159 115.535 35.7609 114.826 35.5713C113.874 35.2038 104.653 35.0237 101.978 35.5818C101.269 35.7735 100.714 36.3264 100.525 37.0351C100.095 38.9202 100.062 42.9959 100.535 44.9231C100.727 45.6318 101.28 46.1868 101.988 46.3764C103.874 46.8103 112.836 46.8714 114.837 46.3764C115.545 46.1847 116.1 45.6318 116.29 44.9231C116.748 42.8695 116.781 39.0466 116.279 37.0246Z"
        fill="#868C98"
      />
      <path
        d="M111.119 40.976L106.822 38.5117V43.4404L111.119 40.976Z"
        fill="white"
      />
      <path
        d="M23.5298 28.5847C23.5298 28.5847 17.5225 26.7951 15.7186 32.7759C17.5224 26.7951 11.5273 24.9647 11.5273 24.9647C11.5273 24.9647 17.5348 26.7542 19.3386 20.7734C17.5348 26.7542 23.5298 28.5847 23.5298 28.5847Z"
        fill="white"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M111.68 131.774C111.68 131.774 106.549 137.792 112.53 142.926C106.549 137.792 101.378 143.776 101.378 143.776C101.378 143.776 106.508 137.757 100.527 132.624C106.508 137.757 111.68 131.774 111.68 131.774Z"
        fill="white"
        stroke="#868C98"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoTransactions;
